import { render } from "./SettingsEmailsTemplates.vue?vue&type=template&id=28b179a2&scoped=true"
import script from "./SettingsEmailsTemplates.vue?vue&type=script&lang=js"
export * from "./SettingsEmailsTemplates.vue?vue&type=script&lang=js"

import "./SettingsEmailsTemplates.vue?vue&type=style&index=0&id=28b179a2&lang=scss"
import "./SettingsEmailsTemplates.vue?vue&type=style&index=1&id=28b179a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b179a2"]])

export default __exports__